<template>
    <v-container fluid>
        <SToolbar>
            <KpIcon icon-cls="ic-20 ic-dashboard ic-col-grey" />
            <v-toolbar-title>{{ $t('dashboard') }}</v-toolbar-title>
        </SToolbar>

        <!-- top row, 3 cols with cards -->
        <v-row>
            <v-col cols="12" lg="4" class="d-flex">
                <WelcomeCard :user="user" height="180px" class="flex-grow-1" />
            </v-col>
            <v-col cols="12" lg="4" class="d-flex">
                <PublishInfoCard height="180px" class="flex-grow-1" />
            </v-col>
            <v-col cols="12" lg="4" class="d-flex">
                <FrontpageCard height="180px" class="flex-grow-1" />
            </v-col>
        </v-row>

        <!-- 2nd row: event table and more cards -->
        <v-row>
            <v-col cols="12" lg="9">
                <EventList
                    session-key="event-home"
                    display-context="dashboard"
                    height="calc(var(--usable-height-with-double-toolbar) - 200px)"
                />
            </v-col>
            <v-col cols="12" lg="3" class="d-flex flex-column" style="gap: 25px">
                <NewsletterInfoCard height="180px" />
                <GenericCard color="white" :href="globalParam('dashboard.kulturpartner_werden_url')" target="_blank">
                    <v-card-text>
                        <p class="card-title">
                            <KpIcon icon-cls="handshake" color="black" /> {{ $t('kulturpartner_werden') }}
                        </p>
                        <p>
                            Mit einer Kulturpartnerschaft stärkst du unser Portal und unser Bestreben für die
                            Kulturberichterstattung und Vermittlung im Kanton Thurgau.
                        </p>
                        <p>
                            <KpIcon icon-cls="arrow-bigright" color="grey" />
                            {{ $t('more_infos') }}
                        </p>
                    </v-card-text>
                </GenericCard>

                <GenericCard color="white" :href="globalParam('dashboard.werbung_schalten_url')" target="_blank">
                    <v-card-text>
                        <p class="card-title">
                            <KpIcon icon-cls="rocket" color="black" /> {{ $t('publish_commercial') }}
                        </p>
                        <p>
                            Mit einer Anzeige auf www.thurgaukultur.ch erreichst du ein interessiertes, kulturaffines
                            Zielpublikum.
                        </p>
                        <p>
                            <KpIcon icon-cls="arrow-bigright" color="grey" />
                            {{ $t('more_infos') }}
                        </p>
                    </v-card-text>
                </GenericCard>
            </v-col>
        </v-row>
    </v-container>
</template>

<script lang="ts">
import Vue from 'vue';
import { mapState } from 'vuex';
import WelcomeCard from '@/components/home/WelcomeCard.vue';
import FrontpageCard from '@/components/home/FrontpageCard.vue';
import GenericCard from '@/components/home/GenericCard.vue';
import EventList from '@/components/event/List.vue';
import PublishInfoCard from '@/components/home/PublishInfoCard.vue';
import NewsletterInfoCard from '@/components/home/NewsletterInfoCard.vue';
import { globalParam } from '@/helpers/globals';

export default Vue.extend({
    name: 'HomeViewVeranstalter',
    components: {
        EventList,
        WelcomeCard,
        FrontpageCard,
        GenericCard,
        PublishInfoCard,
        NewsletterInfoCard,
    },
    computed: {
        ...mapState({
            user: (state: any) => state.user.record,
        }),
    },
    methods: {
        globalParam,
    },
});
</script>
